import React from 'react';
import styled from 'styled-components';

import useTranslation from 'next-translate/useTranslation';
import { Track } from '../../../api';

import { TextRegular14 } from '../../common/Text';
import { FlatButtonWhite } from '../../common/Buttons';

import { mobile } from '../../../style/constants';

import { BecomeProButton, BecomeProButtonIcon } from '../Banners';
import Flex from '../../common/Flex';
import Dialog from '../../common/Dialog';

interface ModalProps {
  visible: boolean;
  track: Track;
  onDismiss: () => void;
  onConfirm: () => void;
}

const ActivateTrackModal = ({
  track,
  visible = false,
  onDismiss,
  onConfirm,
}: ModalProps) => {
  const { t } = useTranslation('myTracks');

  return (
    <Dialog open={visible} onClose={onDismiss}>
      <Container>
        <div className="content">
          <TextRegular14 className="title">
            {t('myTracks:make') as string}{' '}
            <strong>“{track.title ?? '<no-title>'}”</strong>{' '}
            {t('myTracks:trackActive') as string}
          </TextRegular14>
          <TextRegular14 className="message">
            {t('myTracks:trackLimitation') as string}
            <strong> “{track.title ?? '<no-title>'}”</strong>
            {t('myTracks:trackArchived') as string}
          </TextRegular14>
          <TextRegular14>{t('myTracks:becomePro') as string}</TextRegular14>
        </div>
        <div className="actions_container">
          <FlatButtonWhite onClick={onConfirm}>
            {t('myTracks:makeOneTrackActive') as string}
          </FlatButtonWhite>
          <Flex
            flexDirection="column"
            alignItems="center"
            className="pro-btn_container"
          >
            <BecomeProButton />
            <BecomeProButtonIcon className="pro-btn_icon" />
          </Flex>
        </div>
      </Container>
    </Dialog>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 70px 40px 70px;
  @media ${mobile} {
    padding: 60px 16px 45px 16px;
  }

  .content {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 28px;
    max-width: 366px;
    @media ${mobile} {
      margin-bottom: 42px;
    }
  }

  .title {
    margin-bottom: 28px;
  }

  .message {
    margin-bottom: 19px;
  }

  .actions_container {
    display: flex;
    flex-wrap: wrap;

    button {
      flex: 1;
      &:first-of-type {
        margin: 0 24px 0 0;
      }
    }

    .pro-btn_icon {
      margin-top: 12px;
    }

    @media ${mobile} {
      justify-content: center;

      button:first-of-type {
        flex: 0 1 100%;
        margin: 0 0 12px 0;
      }

      .pro-btn_container {
        flex: 0 1 100%;

        a {
          width: 100%;
        }
      }
    }
  }
`;

export default ActivateTrackModal;
